import * as ActionsTypes from "../../../common/state/StateConstants";
import { updateObject } from "../../../common/utils/FunctionsUtils";

const initialState = {
  consultingMode: true,
};

const setConsultingMode = (state, action) => {
  return updateObject(state, {
    consultingMode: action?.data,
  });
};

export const TitreReducer = (state = initialState, action) => {
  switch (action?.type) {
    case ActionsTypes.SET_CONSULTING_MODE:
      return setConsultingMode(state, action);
    default:
      return state;
  }
};
